const ShelfType = {
	AnticipatingMild: {
		key: 'AnticipatingMild',
		icon: 'icon-expected-icon',
		text: 'Anticipating',
		longText: 'Anticipating',
		doRenderInList: true,
	},
	AnticipatingHigh: {
		key: 'AnticipatingHigh',
		icon: 'icon-urgent-expected-icon',
		text: 'Anticipating+',
		longText: 'Highly Anticipating',
		doRenderInList: true,
	},
	CurrentlyReading: {
		key: 'CurrentlyReading',
		icon: 'icon-read-icon',
		text: 'Reading',
		longText: 'Currently Reading',
		doRenderInList: true,
	},
	FinishedReading: {
		key: 'FinishedReading',
		icon: 'icon-add-to-working-list-icon',
		text: 'Finished',
		longText: 'Finished',
		doRenderInList: true,
	},
	DidntFinish: {
		key: 'DidntFinish',
		icon: 'icon-close-icon',
		text: 'DNF',
		longText: 'Did Not Finish',
		doRenderInList: true,
	},
	Favorites: {
		key: 'Favorites',
		icon: 'icon-rating-inactive-icon',
		text: 'Favorite',
		longText: 'Favorite!',
		doRenderInList: true,
	},
	Clear: {
		key: 'Clear',
		icon: 'icon-rating-inactive-icon',
		text: 'Clear',
	},
};

export default ShelfType;
